export default __webpack_public_path__ + "static/checkout-page-78e2d5fb5ae135771da66b01b375df56.png";